import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RoamsureQuickAccess = () => {
  const travelRequests = [
    {
      id: 'TR-2024-001',
      traveler: 'Sarah Johnson',
      destination: 'London, UK',
      date: '2024-01-20',
      status: 'pending',
      priority: 'high'
    },
    {
      id: 'TR-2024-002',
      traveler: 'Michael Chen',
      destination: 'Tokyo, Japan',
      date: '2024-01-22',
      status: 'approved',
      priority: 'normal'
    },
    {
      id: 'TR-2024-003',
      traveler: 'Emily Rodriguez',
      destination: 'Dubai, UAE',
      date: '2024-01-25',
      status: 'pending',
      priority: 'urgent'
    }
  ];

  const remoteWorkPermissions = [
    {
      id: 'RW-2024-001',
      employee: 'David Kim',
      location: 'Barcelona, Spain',
      duration: '2 weeks',
      status: 'active',
      compliance: 'verified'
    },
    {
      id: 'RW-2024-002',
      employee: 'Lisa Thompson',
      location: 'Singapore',
      duration: '1 month',
      status: 'pending',
      compliance: 'review'
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'approved': case'active': return 'text-success bg-success/10 border-success/20';
      case 'pending': return 'text-warning bg-warning/10 border-warning/20';
      case 'rejected': return 'text-error bg-error/10 border-error/20';
      default: return 'text-muted-foreground bg-muted/10 border-muted/20';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'urgent': return 'text-error';
      case 'high': return 'text-warning';
      case 'normal': return 'text-primary';
      default: return 'text-muted-foreground';
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
      {/* Travel Requests Widget */}
      <div className="glass-container rounded-xl border border-border/50">
        <div className="p-6 border-b border-border/50">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
                <Icon name="Plane" size={20} color="white" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-foreground">Travel Requests</h3>
                <p className="text-sm text-muted-foreground">Pending approvals</p>
              </div>
            </div>
            <Button variant="ghost" size="sm" iconName="ExternalLink">
              View All
            </Button>
          </div>
        </div>
        <div className="p-6 space-y-3">
          {travelRequests?.map((request) => (
            <div
              key={request?.id}
              className="p-3 rounded-lg border border-border/30 hover:bg-white/5 transition-all duration-200"
            >
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-1">
                    <span className="text-xs font-mono text-muted-foreground">{request?.id}</span>
                    <Icon name="Flag" size={12} className={getPriorityColor(request?.priority)} />
                  </div>
                  <h4 className="text-sm font-semibold text-foreground">{request?.traveler}</h4>
                </div>
                <div className={`px-2 py-0.5 rounded text-xs font-medium ${getStatusColor(request?.status)}`}>
                  {request?.status}
                </div>
              </div>
              <div className="flex items-center space-x-4 text-xs text-muted-foreground">
                <div className="flex items-center space-x-1">
                  <Icon name="MapPin" size={12} />
                  <span>{request?.destination}</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Icon name="Calendar" size={12} />
                  <span>{request?.date}</span>
                </div>
              </div>
              {request?.status === 'pending' && (
                <div className="flex items-center space-x-2 mt-3">
                  <Button variant="success" size="xs" iconName="Check" className="flex-1">
                    Approve
                  </Button>
                  <Button variant="outline" size="xs" iconName="Eye" className="flex-1">
                    Review
                  </Button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      {/* Remote Work Permissions Widget */}
      <div className="glass-container rounded-xl border border-border/50">
        <div className="p-6 border-b border-border/50">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-accent to-secondary flex items-center justify-center">
                <Icon name="MapPin" size={20} color="white" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-foreground">Remote Work</h3>
                <p className="text-sm text-muted-foreground">Active permissions</p>
              </div>
            </div>
            <Button variant="ghost" size="sm" iconName="ExternalLink">
              View All
            </Button>
          </div>
        </div>
        <div className="p-6 space-y-3">
          {remoteWorkPermissions?.map((permission) => (
            <div
              key={permission?.id}
              className="p-3 rounded-lg border border-border/30 hover:bg-white/5 transition-all duration-200"
            >
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-1">
                    <span className="text-xs font-mono text-muted-foreground">{permission?.id}</span>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground">{permission?.employee}</h4>
                </div>
                <div className={`px-2 py-0.5 rounded text-xs font-medium ${getStatusColor(permission?.status)}`}>
                  {permission?.status}
                </div>
              </div>
              <div className="flex items-center space-x-4 text-xs text-muted-foreground mb-2">
                <div className="flex items-center space-x-1">
                  <Icon name="MapPin" size={12} />
                  <span>{permission?.location}</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Icon name="Clock" size={12} />
                  <span>{permission?.duration}</span>
                </div>
              </div>
              <div className="flex items-center justify-between pt-2 border-t border-border/30">
                <div className="flex items-center space-x-1">
                  <Icon 
                    name={permission?.compliance === 'verified' ? 'CheckCircle' : 'AlertCircle'} 
                    size={14} 
                    className={permission?.compliance === 'verified' ? 'text-success' : 'text-warning'} 
                  />
                  <span className="text-xs text-muted-foreground">
                    Compliance: {permission?.compliance}
                  </span>
                </div>
                <Button variant="ghost" size="xs" iconName="Settings">
                  Manage
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RoamsureQuickAccess;